import CookiesManager from '../utils/cookies-manager';


export default function initInformationsBanner() : void {
    const $informationsBanner = document.querySelectorAll<HTMLElement>('.informations-banner');

    $informationsBanner.forEach($container => {
        new InformationsBanner($container);
    });
}

class InformationsBanner {
    $el: HTMLElement;
    name: string;
    $closeButton: HTMLButtonElement | null;

    constructor($el: HTMLElement) {
        this.$el = $el;
        this.name = $el.dataset.name || '';
        this.$closeButton = $el?.querySelector<HTMLButtonElement>('.informations-banner-close-button');

        if (CookiesManager.getCookie(`info_banner[${this.name}]`)) {
            this.closeBanner();
        }

        if (this.$closeButton && this.name) {
            this.$closeButton?.addEventListener('click', this.closeBanner.bind(this));
        }
    }

    /**
     * Ouvre la bannière d'informations
     *
     * @return {void}
     */
    openBanner(): void {
        this.$el.classList.add('open');
    }

    /**
     * Ferme la bannière et créer un cookie
     *
     * @return {void}
     */
    closeBanner(): void {
        this.$el.classList.remove('open');
        CookiesManager.setCookie(`info_banner[${this.name}]`, 'opened', 30);
    }
}
